// extracted by mini-css-extract-plugin
export default {"Skeleton":"ucKJo7o9"};